import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { ThemeTag, UpdateThemeTag } from "../types";
import { ThemeTagDB } from "./ThemeTagDB";

export const updateThemeTag = async (
  tagId: string,
  tag: UpdateThemeTag,
): Promise<ThemeTag> => {
  const collectionRef = collection(db, "themeTags");
  await updateDoc(doc(collectionRef, tagId), tag);

  const updatedTagSnapshot = await getDoc(doc(collectionRef, tagId));

  const updatedTag = new ThemeTagDB(updatedTagSnapshot);

  return updatedTag.toThemeTag();
};
